<template>
  <el-container class="layout">
    <div class="asside" :style="fixed ? 'width: 60px' : 'width: 240px'">
      <left-menu @fixed="fixFn"></left-menu>
      <!-- <div class="wrapper-logo" @click="pageToHome">
        <img src="@/assets/img/layout/logo.png" />
      </div>
      <Sidebar></Sidebar> -->
      <!-- <el-scrollbar wrapClass="scrollbar-wrapper">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>导航一</span>
            </template>
            <el-menu-item-group>
              <template slot="title">分组一</template>
              <el-menu-item index="1-1">选项1</el-menu-item>
              <el-menu-item index="1-2">选项2</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group title="分组2">
              <el-menu-item index="1-3">选项3</el-menu-item>
            </el-menu-item-group>
            <el-submenu index="1-4">
              <template slot="title">选项4</template>
              <el-menu-item index="1-4-1">选项1</el-menu-item>
            </el-submenu>
          </el-submenu>
          <el-menu-item index="4">
            <i class="el-icon-setting"></i>
            <span slot="title">导航四</span>
          </el-menu-item>
        </el-menu>
      </el-scrollbar> -->
    </div>
    <div class="layout-content">
      <el-container class="container">
        <el-header class="header" height="70px">
          <navbar></navbar>
        </el-header>
        <el-container class="layout-body">
          <el-main class="main">
            <!-- <el-main class="content"></el-main> -->
            <transition name="fade" mode="out-in">
              <!-- :key="$route.path" -->
              <!-- {{ $route.path }}
        {{ $route.fullPath }} -->
              <router-view />
            </transition>
          </el-main>
          <!-- v-if="drawer" -->
          <div class="right-layout" :class="{ 'right-layout-active': drawer }">
            <div class="dialog-head">
              <div class="dialog-head-title">上传图片{{ drawer }}</div>
              <div class="dialog-head-close" @click="closeDrawer"></div>
            </div>
          </div>
        </el-container>
      </el-container>
    </div>

    <template v-if="newUploads.length">
      <div v-show="showBall" class="process-ball" @click="showBall = false">
        <el-badge :value="newUploads.length" class="item">
          <img src="../../assets/img/layout/icon_upload.png" />
        </el-badge>
      </div>

      <div
        v-show="!showBall"
        class="process-dialog"
        :class="{ 'process-dialog-active': !showBall }"
      >
        <div class="dialog-head">
          <div class="dialog-head-title">上传文件</div>
          <div class="dialog-head-close" @click="showBall = true"></div>
        </div>
        <div class="dialog-body padding">
          <el-table header-row-class-name="header-row" :data="newUploads">
            <el-table-column prop="courseInfo" label="资料">
              <template slot-scope="scope">
                <div class="file-item">
                  <el-image
                    class="file-item-cover"
                    fit="contain"
                    :src="
                      'https://image.renrenjiang.cn/teacher_center/website/file/icon_file_' +
                      scope.row.fileFix +
                      '.png'
                    "
                  ></el-image>
                  <div class="file-item-title">
                    {{ scope.row.activity.title }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="大小">
              <template slot-scope="scope">
                <el-progress
                  :show-text="false"
                  :percentage="scope.row.schedule - 0"
                ></el-progress>
                <div class="process-line">
                  <div>{{ scope.row.fileSize }} M</div>
                  <div>
                    {{
                      scope.row.status === 1
                        ? scope.row.schedule + "%"
                        : scope.row.status === 0
                        ? "上传失败"
                        : scope.row.status === 2
                        ? "转码中..."
                        : scope.row.status === 3
                        ? "成功"
                        : scope.row.status === 5
                        ? "成功"
                        : "失败"
                    }}
                    <el-button
                      v-if="scope.row.status === 0"
                      :loading="loading"
                      @click="retryUpload(scope.row.activity.id)"
                    >
                      续传
                    </el-button>
                    <el-button
                      v-if="scope.row.status === 4"
                      @click="restartUpload(scope.row.activity.id)"
                    >
                      重传
                    </el-button>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="操作"
              align="right"
              width="70px"
            >
              <template slot-scope="scope">
                <div>
                  <el-button
                    type="text"
                    size="small"
                    @click.native.prevent="deleteUpload(scope.row.activity.id)"
                  >
                    {{ scope.row.schedule == 100 ? "消 除" : "取 消" }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </template>

    <!-- 讲师助手 -->
    <!-- <div
      v-if="user && user.id === 21217432"
      class="float-customer"
      :class="{ expend: helpExpend, anim: helpAnim, hidden: helpWindow }"
    >
      <div class="float-customer-ip"></div>
      <div class="float-customer-questions">
        <div class="question-block">
          <div class="question-title">为你推荐内容</div>
          <div class="question-subtitle">当前位于【课程管理-视频课】</div>
          <div class="question-list">
            <div v-for="i in 6" v-bind:key="i" class="question-item">
              如何识别行业市场的“搜索热度”？
            </div>
          </div>
        </div>
        <div @click="closeCustomerExpend" class="float-customer-close"></div>
      </div>
      <div @click="openCustomerWindow" class="float-customer-btn">讲师助手</div>
    </div> -->

    <!-- 讲师助手窗口 -->
    <div class="customer-window" :class="{ active: helpWindow }">
      <div class="customer-window-head">
        <div @click="helpSearch = true" class="customer-window-search">
          <el-image
            class="search-icon"
            src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_win_search.png"
          ></el-image>
          <div class="search-text">有问题？搜一搜</div>
        </div>
        <div class="customer-window-keywords">
          <div class="keyword-item">讲师资质</div>
          <div class="keyword-item">课程审核</div>
          <div class="keyword-item">资金提现</div>
          <div class="keyword-item">直播挂载</div>
        </div>
      </div>
      <div class="customer-window-body">
        <div class="window-body-title">
          <div class="title-text">自主工具</div>
        </div>
        <div class="window-body-quicks">
          <div class="quick-item">
            <el-image
              class="quick-item-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_tool_teacher.png"
            ></el-image>
            <div class="quick-item-text">讲师资质</div>
          </div>
          <div class="quick-item">
            <el-image
              class="quick-item-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_tool_course.png"
            ></el-image>
            <div class="quick-item-text">课程审核</div>
          </div>
          <div class="quick-item">
            <el-image
              class="quick-item-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_tool_cash.png"
            ></el-image>
            <div class="quick-item-text">资金提现</div>
          </div>
          <div class="quick-item">
            <el-image
              class="quick-item-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_tool_live.png"
            ></el-image>
            <div class="quick-item-text">直播挂课</div>
          </div>
        </div>
        <div class="window-body-title">
          <div class="title-text">猜你想问</div>
          <div class="title-btn">
            <div class="title-btn-text">换一换</div>
            <el-image
              class="title-btn-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_qa_refresh.png"
            ></el-image>
          </div>
        </div>
        <div class="window-body-questions">
          <div class="question-item">
            <el-image
              class="question-item-icon"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_qa_icon.png"
            ></el-image>
            <div class="question-item-content">
              【玩转搜索】如何做好商品的主图优化如何做好商品的主图优化？
            </div>
            <el-image
              class="question-item-arrow"
              src="https://image.renrenjiang.cn/teacher_center/douyin/icon_preview_arrow.png"
            ></el-image>
          </div>
        </div>
      </div>
      <div class="customer-window-search-block" :class="{ active: helpSearch }">
        <div class="search-block">
          <div class="search-block-head">
            <el-input
              v-model="helpKeyword"
              class="search-block-input"
              placeholder="有问题？搜一搜"
              size="small"
            >
              <el-image
                slot="prefix"
                fit="contain"
                class="input-search-icon"
                src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_win_search.png"
              ></el-image>
            </el-input>
            <div @click="helpSearch = false" class="search-block-btn">取消</div>
          </div>
          <div class="search-block-body">
            <div class="search-block-title">
              <div class="title-text">搜索历史</div>
            </div>
            <div class="search-block-title">
              <div class="title-text">热门搜索</div>
            </div>
            <div class="search-block-hots">
              <div class="hot-item">
                <div class="hot-item-num">1</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">2</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">3</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">4</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">5</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">6</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">7</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
              <div class="hot-item">
                <div class="hot-item-num">8</div>
                <div class="hot-item-text">讲师资质审核</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="customer-window-floating">
        <div class="floating-block">
          <el-image
            class="floating-icon"
            src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_call_icon.png"
          ></el-image>
          <div class="floating-text">联系助手</div>
        </div>
      </div>
      <div class="customer-window-ip">
        <el-image
          class="window-ip-img"
          src="https://cdn-hz.renrenjiang.cn/teacher_center/douyin/icon_customer_window_ip.png"
        ></el-image>
        <div class="window-ip-text">您好，我是您的讲师助手</div>
      </div>
      <div @click="closeCustomerWindow" class="customer-window-close"></div>
    </div>
  </el-container>
</template>
<script setup>
// import Sidebar from "@/views/layout/Sidebar/index.vue";
import LeftMenu from "@/views/layout/left-menu.vue";
import Navbar from "@/views/layout/Navbar.vue";
</script>
<script>
import { mapGetters } from "vuex";
import Navbar from "@/views/layout/Navbar.vue";
</script>
<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showBall: false,
      helpExpend: false,
      helpWindow: false,
      helpAnim: false,
      helpSearch: false,
      helpKeyword: "",
      user: null,
      fixed: false,
    };
  },
  computed: {
    ...mapGetters({ drawer: "drawer", uploads: "uploads" }),
    newUploads() {
      return this.uploads.filter((item) => item.status < 2);
    },
  },
  mounted() {
    this.showBall = false;
    this.user = this.$rrj.storage.get("_ukit");
    if (this.user.id === 21217432) {
      // setTimeout(() => {
      //   this.helpAnim = true;
      //   setTimeout(() => {
      //     this.helpExpend = true;
      //   }, 2000);
      // }, 2000);
    }
  },
  methods: {
    fixFn(e) {
      this.fixed = e;
    },
    openCustomerWindow() {
      this.helpExpend = false;
      this.helpWindow = true;
    },
    closeCustomerWindow() {
      this.helpWindow = false;
    },
    closeCustomerExpend() {
      this.helpExpend = false;
    },
    closeDrawer() {
      this.$store.dispatch("TOGGLEDRAWER").then(() => {});
    },
    deleteUpload(activityId) {
      this.$confirm("是否删除该上传任务?", "提示", {
        type: "warning",
      })
        .then(() => {
          for (let i = 0; i < this.uploads.length; i++) {
            if (this.uploads[i].activity.id === activityId) {
              this.$store.dispatch("deleteUpload", {
                activityId,
                upload: this.uploads[i],
              });
            }
          }
        })
        .catch((err) => {
          /* eslint-disable */
          console.log(err);
          /* eslint-enable */
          this.$message("取消操作");
        });
    },
    retryUpload(activityId) {
      setTimeout(() => {
        this.loading = false;
      }, 2000);
      for (let i = 0; i <= this.uploads.length; i++) {
        if (this.uploads[i].activity.id === activityId) {
          this.$store.dispatch("retryUpload", activityId);
        }
      }
    },
    restartUpload(activityId) {
      this.$store.dispatch("restartUpload", activityId);
    },
    pageToHome() {
      this.$router.push("/website");
    },
  },
};
</script>
<style lang="scss">
.layout {
  height: 100%;
  background-color: #f7f8fa;
  // height: 0;
  // flex-grow: 1;
  // display: flex;
  // align-items: flex-start;

  .wrapper-logo {
    position: sticky;
    top: 0;
    z-index: 10;
    padding: 20px 27px 31px 29px;
    // width: 142px;
    // height: 22px;
    background-color: #09244f;
    img {
      width: 142px;
    }
    cursor: pointer;
  }

  .asside {
    // position: absolute;
    //background-color: #09244f;
    height: 100%;
    transition: all 0.1s;
  }

  .asside::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
  }

  .layout-content {
    // width: calc(100vw - 200px);
    // width
    flex: 1;
    overflow-x: scroll;

    .container {
      background-color: #f7f8fa;
      padding-left: 20px;
      min-width: 1240px;
      height: 100%;
    }

    .header {
      height: 70px;
      background-color: #fff;
      box-shadow: 0px 4px 10px 0px rgba(85, 56, 56, 0.1);
      z-index: 10;
    }

    .main {
      padding: 20px 20px 20px 0;
    }
  }

  .right-layout {
    transform: scale(0, 0);
    width: 0px;
    background-color: #105cfb;
    transition: width 0.5s;
  }

  .right-layout-active {
    width: 300px;
    transform: scale(1, 1);
  }
}

.layout-body {
  height: 0;
}

.process-ball {
  position: fixed;
  right: 15px;
  bottom: 20px;
  width: 170px;
  height: 54px;
  img {
    width: 152px;
    height: 54px;
  }
}

@keyframes processAnimation {
  from {
    width: 300px;
    height: 200px;
  }
  to {
    width: 500px;
    height: 500px;
  }
}

.process-dialog {
  position: fixed;
  right: 0;
  bottom: 0;
  width: 300px;
  height: 200px;
  // animation: processAnimation 0.3s ease-out;
  box-shadow: 0px 2px 6px 0px rgba(131, 154, 246, 0.302);

  .dialog-body {
    height: 100%;
  }

  .process-line {
    display: flex;
    justify-content: space-between;
  }
}

.process-dialog-active {
  width: 500px;
  height: 500px;
  animation: processAnimation 0.3s ease-in;
}

.float-customer {
  position: fixed;
  bottom: 80px;
  right: 20px;
  z-index: 100;
  width: 100px;

  display: flex;
  flex-direction: column;
  align-items: center;

  transition: all 0.3s;

  &.hidden {
    transform: translateX(130px);
  }

  &.anim {
    .float-customer-ip {
      animation: customerAnim 0.6s 3;
    }
  }

  &.expend {
    width: 160px;

    .float-customer-ip {
      transform: translateY(20px);
    }

    .float-customer-btn {
      width: 160px;
      height: 44px;
      line-height: 44px;
      border-radius: 0 0 12px 12px;
    }

    .float-customer-questions {
      height: 368px;
    }
  }

  .float-customer-ip {
    width: 60px;
    height: 60px;
    background-size: 100% 100%;
    background-image: url(https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_ip.png);
    transform: translateY(6px);
    z-index: 200;
  }

  .float-customer-questions {
    position: relative;
    width: 100%;
    height: 0;
    display: flex;
    overflow: hidden;
    align-items: center;
    flex-direction: column;
    border-radius: 12px 12px 0 0;
    background-image: linear-gradient(
      180deg,
      #0366ff 0%,
      rgba($color: #0366ff, $alpha: 0.2) 30%,
      #ffffff 110%
    );
    transition: all 0.3s;

    .float-customer-close {
      position: absolute;
      top: 8px;
      right: 8px;
      width: 24px;
      height: 24px;
      background-size: 20px 20px;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url(https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_close.png);
      border-radius: 6px;
      cursor: pointer;

      &:hover {
        background-color: rgba($color: #ffffff, $alpha: 0.2);
      }
    }

    .question-block {
      width: 160px;
      height: 368px;

      box-sizing: border-box;
      padding-top: 16px;

      display: flex;
      flex-direction: column;
      align-items: center;

      .question-title {
        margin-bottom: 4px;
        margin-top: 11px;

        text-align: center;
        font-weight: 500;
        line-height: 20px;
        font-size: 14px;
        color: #ffffff;
      }

      .question-subtitle {
        width: 140px;
        height: 16px;
        text-align: center;
        line-height: 16px;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .question-list {
        width: 152px;
        flex-grow: 1;
        margin-top: 8px;
        border-radius: 8px 8px 0 0;
        background-color: #ffffff;
        box-sizing: border-box;
        padding: 8px 0;

        .question-item {
          word-wrap: break-word;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          color: #090909;
          cursor: pointer;
          display: -webkit-box;
          font-size: 12px;
          line-height: 18px;
          overflow: hidden;
          padding: 4px 12px;
          box-sizing: border-box;
          word-break: break-all;

          &:hover {
            color: #0366ff;
          }
        }
      }
    }
  }

  .float-customer-btn {
    width: 100px;
    height: 30px;
    z-index: 100;
    border-radius: 15px;
    background-image: linear-gradient(180deg, #3f96ff 0%, #3661fd 81%);

    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.3s;
  }
}

@keyframes customerAnim {
  0% {
    transform: translateY(6px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(6px);
  }
}

.customer-window {
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 380px;
  height: 80%;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  z-index: 500;

  transition: all 0.3s;
  transform: translateX(410px);

  &.active {
    transform: translateX(0);
  }
  // filter: drop-shadow(0 4px 32px rgba(0, 0, 0, 0.12));

  .customer-window-close {
    position: absolute;
    top: 25px;
    right: 25px;
    width: 24px;
    height: 24px;
    background-size: 20px 20px;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_close.png);
    border-radius: 6px;
    cursor: pointer;

    &:hover {
      background-color: rgba($color: #ffffff, $alpha: 0.2);
    }
  }

  .customer-window-head {
    position: relative;
    width: 380px;
    height: 200px;
    background-size: 100% 100%;
    background-image: url(https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_win_bgimg.png);

    padding-top: 84px;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    flex-direction: column;

    .customer-window-search {
      width: 330px;
      height: 32px;
      border-radius: 16px;
      border: 1px solid rgba($color: #ffffff, $alpha: 0.8);
      background-color: rgba($color: #ffffff, $alpha: 0.8);

      display: flex;
      align-items: center;

      padding: 0 16px;
      box-sizing: border-box;
      cursor: pointer;

      &:hover {
        border-color: #0366ff;
      }

      .search-icon {
        width: 24px;
        height: 24px;
      }

      .search-text {
        margin-left: 6px;
        line-height: 20px;
        font-size: 14px;
        color: #acacac;
      }
    }

    .customer-window-keywords {
      width: 330px;
      margin-top: 16px;

      display: flex;
      align-items: center;

      .keyword-item {
        padding: 0 5px;
        margin-right: 10px;
        border-radius: 4px;
        background-color: rgba($color: #ffffff, $alpha: 0.2);

        line-height: 20px;
        font-size: 12px;
        color: #ffffff;
        cursor: pointer;

        &:hover {
          background-color: rgba($color: #ffffff, $alpha: 0.25);
        }
      }
    }
  }

  .customer-window-body {
    position: absolute;
    top: 168px;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 20px 20px 0 0;
    background-color: #ffffff;

    padding: 25px;
    box-sizing: border-box;

    .window-body-title {
      line-height: 25px;
      font-weight: 500;
      font-size: 16px;
      color: #090909;

      display: flex;
      align-items: center;
      justify-content: space-between;

      .title-btn {
        display: inline-flex;
        align-items: center;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }

        .title-btn-text {
          font-weight: normal;
          font-size: 14px;
          color: #0366ff;
        }

        .title-btn-icon {
          margin-left: 6px;
          width: 16px;
          height: 16px;
        }
      }
    }

    .window-body-quicks {
      display: flex;
      flex-wrap: wrap;
      margin: 15px 0;

      .quick-item {
        width: 140px;
        height: 32px;
        padding: 0 10px;
        border-radius: 6px;
        margin-bottom: 10px;
        background-color: #f0f6ff;

        display: inline-flex;
        align-items: center;
        cursor: pointer;

        &:nth-child(2n) {
          margin-left: 10px;
        }

        .quick-item-icon {
          width: 20px;
          height: 20px;
        }

        .quick-item-text {
          margin-left: 10px;
          font-size: 14px;
          color: #090909;
        }
      }
    }

    .window-body-questions {
      margin: 15px 0;

      .question-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        cursor: pointer;

        &:hover {
          .question-item-content {
            color: #0366ff;
          }
        }

        .question-item-icon {
          width: 20px;
          height: 20px;
        }

        .question-item-content {
          width: 0;
          height: 20px;
          flex-grow: 1;

          line-height: 20px;
          font-size: 14px;
          color: #090909;

          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }

        .question-item-arrow {
          margin-left: 20px;
          width: 20px;
          height: 20px;
        }
      }
    }
    // <div class="window-body-questions">
    //       <div class="question-item">
    //         <el-image
    //           class="question-item-icon"
    //           src="https://image.renrenjiang.cn/teacher_center/douyin/icon_customer_qa_icon.png"
    //         ></el-image>
    //         <div class="question-item-content">
    //           【玩转搜索】如何做好商品的主图优化如何做好商品的主图优化？
    //         </div>
    //         <el-image
    //           class="question-item-arrow"
    //           src="https://image.renrenjiang.cn/teacher_center/douyin/icon_preview_arrow.png"
    //         ></el-image>
  }

  .customer-window-ip {
    position: absolute;
    top: 20px;
    left: 25px;

    display: flex;
    align-items: center;

    .window-ip-img {
      width: 50px;
      height: 48px;
      filter: drop-shadow(0 0 6px rgba(3, 102, 255, 0.42));
    }

    .window-ip-text {
      margin-left: 16px;
      line-height: 22px;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
    }
  }

  .customer-window-search-block {
    position: absolute;
    top: 58px;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 20px 20px 0 0;
    background-color: #ffffff;
    transition: all 0.3s;
    transform: translateY(100%);
    opacity: 0;

    &.active {
      transform: translateY(0);
      opacity: 1;
    }

    .search-block {
      .search-block-head {
        padding: 16px;
        box-sizing: border-box;

        display: flex;
        align-items: center;

        .search-block-input {
          border-radius: 16px;

          .el-input__inner {
            border-radius: 16px;
          }

          .input-search-icon {
            width: 20px;
            height: 32px;
          }
        }

        .search-block-btn {
          width: 28px;
          color: #686767;
          cursor: pointer;
          font-size: 12px;
          margin-left: 8px;
        }
      }

      .search-block-body {
        padding: 16px;
        box-sizing: border-box;

        .search-block-title {
          align-items: center;
          display: flex;
          justify-content: space-between;
          padding-bottom: 16px;

          .title-text {
            color: #acacac;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 16px;
          }
        }

        .search-block-hots {
          display: flex;
          flex-wrap: wrap;
          flex-direction: column;

          width: 330px;
          height: 140px;

          .hot-item {
            width: 50%;
            height: 20px;
            margin-bottom: 14px;

            display: inline-flex;
            align-items: center;

            .hot-item-num {
              align-items: center;
              background: #dadbe0;
              border-radius: 4px;
              color: #ffffff;
              display: inline-flex;
              justify-content: center;
              flex-shrink: 0;
              font-size: 12px;
              font-weight: 600;
              height: 16px;
              width: 16px;
            }

            &:nth-child(1) {
              .hot-item-num {
                background: linear-gradient(
                  317.73deg,
                  #ffa800 -1.64%,
                  #ffc700 97.02%
                );
              }
            }

            &:nth-child(2) {
              .hot-item-num {
                background: linear-gradient(315deg, #9eaae3, #bfc9f9);
              }
            }

            &:nth-child(3) {
              .hot-item-num {
                background: linear-gradient(315deg, #e6a06e, #f0ad7d);
              }
            }

            .hot-item-text {
              color: #090909;
              flex: 1;
              font-size: 12px;
              margin-left: 8px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  .customer-window-floating {
    position: absolute;
    bottom: 0;
    right: 12px;
    bottom: 100px;

    width: 48px;
    height: 48px;
    border-radius: 24px;
    box-shadow: 0px 4px 10px 0px rgba(0, 43, 143, 0.3);
    background-image: linear-gradient(149deg, #159eff 16%, #0366ff 86%);

    padding: 0 12px;
    box-sizing: border-box;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      width: 150px;
    }

    .floating-block {
      width: 92px;
      height: 48px;
      display: flex;
      align-items: center;

      .floating-icon {
        width: 24px;
        height: 24px;
      }

      .floating-text {
        white-space: nowrap;
        margin-left: 12px;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }
}
</style>
